import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const AsteriskOutlinedIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 18V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18Z"
        fill={color}
        style={{
          fillOpacity: 1,
        }}
      />
      <path
        d="M16.7874 8.08689C17.2496 7.87939 17.803 8.05177 18.0618 8.49997C18.3208 8.9485 18.1929 9.51411 17.7815 9.81052L17.6956 9.86619L7.30398 15.8662C6.8257 16.1423 6.2139 15.9782 5.93777 15.5C5.66169 15.0217 5.82572 14.4099 6.30398 14.1338L16.6956 8.13376L16.7874 8.08689Z"
        fill={color}
        style={{
          fillOpacity: 1,
        }}
      />
      <path
        d="M5.93778 8.49998C6.19669 8.05156 6.75085 7.87905 7.21317 8.0869L7.30399 8.13377L17.6956 14.1338L17.7815 14.1894C18.1929 14.4858 18.3208 15.0515 18.0618 15.5C17.803 15.9482 17.2496 16.1206 16.7874 15.9131L16.6956 15.8662L6.30399 9.86619L6.21805 9.81053C5.80693 9.51408 5.67894 8.94839 5.93778 8.49998Z"
        fill={color}
        style={{
          fillOpacity: 1,
        }}
      />
    </svg>
  );
};
